module.exports = __webpack_public_path__ + "ea875ebfa6eeb927c3b76c339e5fe322.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/booking_holdings_2023_chart.png
// module id = 1641
// module chunks = 0